<ion-header>
  <div class="modal-header">
    <ion-toolbar>
      <div class="modal-title">
        <h3>Request Approval</h3>
      </div>
      <ion-buttons slot="end">
        <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>

  <ion-list>
    <ion-item>
      <ion-label>User or Group</ion-label>
      <ion-chip
        slot="end"
        mode="ios"
        class="select-chip select-outline"
        [outline]="true"
        (click)="showAssigneeOptions()"
      >
        <ion-label>
          {{ assignedToName ?? 'None' }}
          <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
        </ion-label>
      </ion-chip>
    </ion-item>
    <ion-item>
      <ion-label> Message (optional) </ion-label>
      <ion-textarea
        slot="end"
        #markdownInput
        lines="8"
        autoGrow="true"
        placeholder="e.g. Hey can you take a look at this?"
        [(ngModel)]="title"
        class="input-field"
      >
      </ion-textarea>
    </ion-item>
  </ion-list>
  <div style="padding: 0 18px 18px 0" class="flex-space-between">
    <div></div>
    <ion-button [disabled]="isLoading" (click)="submit()">
      Submit
      <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
      <ion-icon name="arrow-forward-outline" class="icon-padded-left button-icon" [hidden]="isLoading"></ion-icon>
    </ion-button>
  </div>
</ion-header>
